export default __webpack_public_path__ + "2cc68be17253c8e460531784d08061d9.svg";